import { useState } from 'react';
import styles from './Profile.module.css';
import commonStyles from "components/commonStyle/commonStyle.module.css";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FaPlusCircle } from "react-icons/fa";
import EditKidProfileForm from 'components/profileForm/editKidProfileForm';
import { useNavigate } from 'react-router-dom';
import { KidsData } from 'modules/profile';
import SuccessPopup from 'components/successPopup/successPopup';

interface EditKidProfileProps {
    kidsData: KidsData[];
    onRefreshKids: () => void;
}

export default function EditKidProfile({ kidsData, onRefreshKids }: EditKidProfileProps) {
    const [visibleIndex, setVisibleIndex] = useState<number | null>(null);
    const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState(false);
    const navigate = useNavigate();

    const toggleFormVisibility = (index: number) => {
        setVisibleIndex(visibleIndex === index ? null : index);
    };

    return (
        <div className={styles.kidsEditForm}>
            {kidsData.map((kid, index) => (
                <div key={kid.id} className={styles.kidItem}>
                    <div className={styles.kidItemHeade}
                        onClick={() => toggleFormVisibility(index)}>
                        <p>
                            {kid.first_name} {kid.last_name}
                        </p>
                        {visibleIndex === index ?
                            <IoIosArrowUp /> :
                            <IoIosArrowDown />}
                    </div>
                    {visibleIndex === index && (
                        <EditKidProfileForm
                            initialValues={{
                                id: kid.id,
                                first_name: kid.first_name,
                                last_name: kid.last_name,
                                birth_date: kid.birth_date,
                                country: kid.country,
                                age: kid.age,
                                zip: kid.zip,
                                city: kid.city,
                                allergy_medication: kid.allergy_medication,
                                street: kid.street,
                                note: kid.note,

                            }}
                            buttonOptions={[
                                {
                                    label: "Abbrechen",
                                    onClick: onRefreshKids,
                                },
                                {
                                    label: "Speichern",
                                },
                            ]}
                            onSubmitSuccess={() => setIsSuccessPopupOpen(true)}
                        />
                    )}
                </div>
            ))}
            <section className={styles.section}>
                <div className={styles.addButtonContainer}>
                    <button
                        type="button"
                        className={`${commonStyles.commonButton} ${styles.addKidButton}`}
                        onClick={() => navigate('/reservierungsportal/NewkidsProfile')}>
                        <span>Kinderprofil hinzufügen</span>
                        <FaPlusCircle className={`${commonStyles.commonButtonIcon} ${styles.buttonIcon}`} />
                    </button>
                </div>
            </section>
            <SuccessPopup isPopupOpen={isSuccessPopupOpen} onClose={() => {
                onRefreshKids();
                setIsSuccessPopupOpen(false);
            }} />
        </div>
    );
}
